<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <InputLabel :label="label" :tooltip="tooltip" :is-error="!!errorMessage" :warning="warning">
    <MultiSelect
      v-model="inputValue"
      v-bind="$attrs"
      :placeholder="placeholder"
      :options="options"
      :disabled="disabled"
    />
    <InputHint :hint="hint" :is-error="!!errorMessage" />
  </InputLabel>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate';
import InputLabel from './InputLabel.vue';
import { computed } from 'vue';
import InputHint from './InputHint.vue';
import MultiSelect from './MultiSelect.vue';
import type { MultiSelectOptionData } from './MultiSelect.vue';

export type { MultiSelectOptionData };

const props = defineProps<{
  name: string;
  label?: string;
  placeholder?: string;
  hint?: string;
  options: MultiSelectOptionData[];
  tooltip?: string;
  warning?: string;
  disabled?: boolean;
}>();

const hint = computed(() => errorMessage.value || props.hint);

const { value: inputValue, errorMessage } = useField<Array<string | number>>(props.name, undefined);
</script>
